
const Footer = () => {

    return (  
        <div className="footer">
            <a href="mailto:michal.diminsky@gmail.com">האתר פותח על ידי מיכל דימינסקי צרפתי</a>
        </div>
    );
}
 
export default Footer;